// Fire-and-forget pageview ping on every route change. Mounted once
// inside <BrowserRouter> so the hook has access to useLocation. Failed
// pings are silenced — analytics tracking should never break the app.
//
// Endpoint is /api/events/pv (NOT /api/analytics/pageview) to dodge
// ad-blocker filter lists. uBlock Origin + Adblock Plus block any path
// containing /analytics/ or /pageview at the browser network layer —
// the request is silently dropped, worker never sees it.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useAnalyticsPageview(): void {
  const location = useLocation();
  useEffect(() => {
    fetch('/api/events/pv', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path: location.pathname }),
      keepalive: true,
    }).catch(() => {
      /* swallow — analytics is best-effort */
    });
  }, [location.pathname]);
}

export function AnalyticsBeacon(): null {
  useAnalyticsPageview();
  return null;
}
